import styled from 'styled-components';

interface StyledCheckProps {
  size?: number;
  value?: boolean;
  checked?: boolean;
}

export const StyledCheck = styled.span<StyledCheckProps>`
  height: ${({ size }) => (size ? `${size}px` : '20px')};
  width: ${({ size }) => (size ? `${size}px` : '20px')};
  border-radius: ${({ size }) => (size ? `${size / 3}px` : '6px')};
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;

  transition: background-color 0.3s ease;
  cursor: pointer;
  background-color: ${({ checked }) => (checked ? '#009EF7' : '#fff')};
  border: 2px solid ${({ checked }) => (checked ? '#009EF7' : '#000')};

  svg {
    width: 14px;
    height: 14px;
    fill: ${({ checked }:any) => (checked ? '#fff' : 'transparent')};
    transition: fill 0.2s ease;
  }

  
`;
